export default function authHeader(formData = false) {
	const accessToken = JSON.parse(localStorage.getItem('bolashak_token'))
	if (formData) {
		return {
			'Content-type': 'multipart/form-data',
			// "Access-Control-Allow-Origin": "http://localhost:3000/",
			// "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
			'Access-Control-Allow-Origin': '*',
			Authorization: 'Bearer ' + accessToken,
			'X-locale': localStorage.getItem('i18nextLng'),
		}
	}
	if (accessToken) {
		return {
			'Content-type': 'application/json',
			// "Access-Control-Allow-Origin": "http://localhost:3000/",
			'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
			'Access-Control-Allow-Origin': '*',
			Authorization: 'Bearer ' + accessToken,
			'X-locale': localStorage.getItem('i18nextLng'),
		}
	} else {
		return {
			'Content-type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'X-locale': localStorage.getItem('i18nextLng'),
		}
	}
}
